module.exports = __webpack_public_path__ + "img/feature_buy_th.7f13f748.png";